<template>
  <div class="flex-container">
    <div class="flex-child">
      <Listbox class="list-box" v-model="selectedSideBar" :options="sidebarList" optionLabel="name" />
    </div>
    <div class="flex-child">
      {{ selectedSideBar.name }}
    </div>
  </div>
</template>

<script setup>
// Copyright (c) 2020-2023 dātma, inc™
//
// Unauthorized copying of this file, via any medium is strictly prohibited
// Proprietary and confidential

import { ref } from 'vue'

const selectedSideBar = ref({ name: 'Tumor Board', code: 'TB' })
const sidebarList = ref([
  { name: 'Tumor Board', code: 'TB' },
  { name: 'Physician Specilaity', code: 'PSPEC' },
  { name: 'Physician Schedule', code: 'PS' },
  { name: 'Discussion', code: 'DS' },
  { name: 'Clinical Stage', code: 'CS' },
  { name: 'Referrals', code: 'RF' },
  { name: 'Recommendations', code: 'RC' },
])
</script>

<style lang="scss" scoped>
.flex-container {
  display: flex;
  height: 100%;
}

.flex-child {
  height: 100%;
  text-align: left;
}

.list-box {
  width: 100%;
  height: 100%;
}
</style>
